"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readableAddress = void 0;
/**
 * Formats an address as a single readable line
 * (`line1, line2, postalCode city, state`). Absent segments are omitted.
 *
 * @param address - the address to format; accepts both the full address shape
 * and the assistant variant where every field is optional
 * @returns the formatted one-line address
 */
const readableAddress = (address) => {
    const cityLine = [address.postalCode, address.city].filter(Boolean).join(' ');
    const segments = [address.line1, address.line2, cityLine, address.state];
    return segments.filter(Boolean).join(', ');
};
exports.readableAddress = readableAddress;
